import { Body, Box, Heading } from '@hover/blueprint';
import React from 'react';

const Header: React.FC = () => (
  <>
    <Box
      mb={600}
      alignItems="center"
      justifyContent="center"
      bg="brandNavy.500"
      px={400}
      py={200}
      borderRadius="8px"
    >
      <Body
        as="h2"
        size={200}
        isBold
        color="neutral.0"
        textTransform="uppercase"
      >
        testimonial
      </Body>
    </Box>
    <Heading
      as="h3"
      fontWeight={700}
      size={{ base: 500, tablet: 600, desktop: 700 }}
      marginBottom={{ base: 700, tablet: 700, desktop: '84px' }}
    >
      Good Guys Contracting
    </Heading>
  </>
);

export default Header;
